// components/shared/CircularProgress.js
import React from 'react';
import { MdSportsScore } from 'react-icons/md';

const CircularProgressComponent = ({ correctAnswers, totalNoOfQuestions, radius = 60 }) => {
  const progressPercentage = (correctAnswers / totalNoOfQuestions) * 100;
  const circumference = 2 * Math.PI * radius;
  const finalOffset = circumference - (progressPercentage / 100) * circumference;

  return (
    <div className="qtestresult__circularProgress">
      <svg className="qtestresult__progressSvg" width="140" height="140" viewBox="0 0 140 140">
        <circle
          className="qtestresult__progressBackground"
          cx="70"
          cy="70"
          r={radius}
          fill="none"
          strokeWidth="10"
        />
        <circle
          className="qtestresult__progressCircle"
          cx="70"
          cy="70"
          r={radius}
          fill="none"
          strokeWidth="10"
          strokeDasharray={circumference}
          strokeDashoffset={circumference}
          style={{
            animation: `progress 1.5s ease-in-out forwards`,
            '--final-offset': finalOffset,
          }}
          transform="rotate(-90 70 70)"
        />
        <g transform="translate(70, 70)">
          <foreignObject x="-20" y="-40" width="40" height="40">
            <div className="qtestresult__scoreIconWrapper">
              <MdSportsScore className="qtestresult__scoreIcon" />
            </div>
          </foreignObject>
          <text
            className="qtestresult__progressText"
            textAnchor="middle"
            dominantBaseline="middle"
          >
            {correctAnswers}/{totalNoOfQuestions}
          </text>
        </g>
      </svg>
    </div>
  );
};

export default CircularProgressComponent;